var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame welcome"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"title"},[_vm._v("WELCOME")]),_c('div',{staticClass:"desc"},[_vm._v("欢迎使用成旅聘通人才库！")]),_c('img',{attrs:{"src":require("../assets/welcome.jpeg"),"alt":""}})])])
}]

export { render, staticRenderFns }